<template>
  <el-container>
    <el-header class="table-header">
      <el-button size="small" type="primary" align="center" @click="submit(form)">{{$t('common.Save')}}</el-button>
      <!--<el-button size="small" align="center" @click="cancel">取消</el-button>-->
    </el-header>
    <el-main class="table-main">
      <el-form :model="form" ref="form" :rules="CommitForm" label-width="80px" size="mini" class="table-form">
        <el-row :gutter="20">
          <el-divider content-position="left">{{$t('common.basicInformation')}}</el-divider>
          <el-col :span="6">
            <el-form-item :label="$t('common.System')" prop="systemId">
              <el-select v-model="form.systemId" size="mini">
                <el-option
                  v-for="item in optionsSys"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.Code')" prop="code">
              <el-input v-model.number="form.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.user.Name')" prop="nameCn">
              <el-input v-model="form.nameCn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.Sex')" prop="sex">
              <el-select v-model="form.sex">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.Birthday')" prop="Birthday">
              <div class="block">
                <el-date-picker
                  v-model="form.birthday"
                  type="date">
                </el-date-picker>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.user.UnitName')" prop="deptName">
              <el-input v-model="form.deptCode" v-if="false"></el-input>
              <el-input v-model="form.deptName" readonly>
                <el-button slot="append" icon="el-icon-search" @click="openTree"></el-button>
              </el-input>
              <template>
                <el-dialog :title="$t('base.info.user.ChooseUnit')" :visible.sync="dialogFormVisible">
                  <el-tree :data="tree" :props="defaultProps" :expand-on-click-node="false" node-key="id"
                           default-expand-all empty-text="暂无数据" ref="changeparent"
                           highlight-current @node-click="handleNodeClick">
                  </el-tree>
                  <div slot="footer" class="dialog-footer">
                    <el-button type="primary" size="mini" @click="comfirm">{{$t('common.Ok')}}</el-button>
                    <el-button size="mini" @click="dialogFormVisible = false">{{$t('common.Cancel')}}</el-button>
                  </div>
                </el-dialog>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.Province')" prop="provinceCode">
              <el-select v-model="form.provinceCode" @change="provinceChange">
                <el-option
                  v-for="item in selectData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.City')" prop="cityCode">
              <el-select v-model="form.cityCode" @change="cityChange">
                <el-option
                  v-for="item in selectCity"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.Area')" prop="areaCode">
              <el-select v-model="form.areaCode" @change="areaChange">
                <el-option
                  v-for="item in selectArea"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.user.WechatNo')" prop="wechatNumber">
              <el-input v-model="form.wechatNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.Mobile')" prop="mobile">
              <el-input v-model="form.mobile"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.Tel')" prop="telephone">
              <el-input v-model="form.telephone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="email" prop="email">
              <el-input v-model="form.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.user.UserType')" prop="typeName">
              <el-select v-model="form.typeCode">
                <el-option
                  v-for="item in optionUserType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base.info.user.EffectiveTime')" prop="value1">
              <div class="block">
                <span class="demonstration"></span>
                <el-date-picker
                  v-model="form.value1"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  :picker-options="pickerOptions2">
                </el-date-picker>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('common.Status')" prop="status">
                <el-switch v-model="statusValue" active-color="#13ce66" inactive-color="#ff6969">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
      <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('common.Address')" prop="address">
              <el-input v-model="form.address" type="textarea"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('common.Remark')" prop="remark">
              <el-input v-model="form.remark" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-divider content-position="left">{{$t('common.AccountingInformation')}}</el-divider>
          <el-col :span="6">
            <el-form-item :label="$t('common.Account')" prop="loginName">
              <el-input v-model="form.loginName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.Pwd')" prop="password">
              <el-input type="password" v-model="form.password"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-divider content-position="left">{{$t('base.info.user.RelationRule')}}</el-divider>
      <header class='mt-20'>
        <el-button style="float: right;" icon="el-icon-plus" class="btn" size="mini" @click="addRole">{{$t('common.AddRow')}}</el-button>
      </header>
      <el-table :data="tableDataRole" border stripe max-height="450" style="width: 80%">
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="code" :label="$t('base.info.user.RuleCode')" align="center"></el-table-column>
        <el-table-column prop="name" :label="$t('base.info.user.RuleName')" align="center"></el-table-column>
        <el-table-column :label="$t('common.Operate')" width="160%" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="deleteRole(scope.$index)">{{$t('common.Delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <role-select :config.sync="roleUrlConfig" :initSelection="tableDataRole" @confirm="RoleUrlConfirm"></role-select>
  </el-container>
</template>

<script>
import Cookies from 'js-cookie'
import moment from 'moment'
import RoleSelect from '@/components/RoleSelect'

export default {
  data () {
    return {
      form: {
        status: 0,
        birthday: '',
        provinceCode: '',
        cityCode: '',
        areaCode: '',
        systemId: '',
        systemName: '',
        deptCode: '',
        deptName: '',
        orgCode: '',
        orgName: '',
        value1: []
      },
      tree: [],
      optionUserType: [],
      tableDataRole: [],
      selectData: [],
      selectCity: [],
      selectArea: [],
      selectOrg: [],
      selectDept: [],
      statusValue: true,
      roleUrlConfig: {
        dialogVisible: false,
        isMulti: true
      },
      options: [{
        value: 1,
        label: '男'
      }, {
        value: 0,
        label: '女'
      }],
      nodeData: {
        code: '',
        label: ''
      },
      defaultProps: {
        children: 'children',
        label: 'label',
        id: 'code'
      },
      dialogFormVisible: false,
      pickerOptions2: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      optionsSys: [],
      birthdayValue: '',
      radio: ''
    }
  },
  components: {
    RoleSelect
  },
  methods: {
    RoleUrlConfirm (selection) {
      this.tableDataRole = selection
    },
    addRole () {
      this.roleUrlConfig.dialogVisible = true
    },
    deleteRole (index) {
      this.tableDataRole.splice(index, 1)
    },
    deptChange (val) {
      var obj = {}
      obj = this.selectData.find(item => {
        return item.value === val
      })
      this.form.deptName = obj.label
    },
    provinceChange (val) {
      this.form.cityCode = ''
      this.form.areaCode = ''
      this.loadCity(val)
    },
    cityChange (val) {
      this.form.areaCode = ''
      this.loadArea(val)
    },
    areaChange () {
      this.$forceUpdate()
    },
    submit (form) {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.form = form
          if (this.statusValue) {
            this.form.status = 50
          } else {
            this.form.status = 30
          }
          for (let i = 0; i < this.optionUserType.length; i++) {
            if (this.optionUserType[i].value === this.form.typeCode) {
              this.form.typeName = this.optionUserType[i].label
            }
          }
          for (let i = 0; i < this.selectData.length; i++) {
            if (this.selectData[i].value === this.form.provinceCode) {
              this.form.provinceName = this.selectData[i].label
            }
          }
          for (let i = 0; i < this.selectCity.length; i++) {
            if (this.selectCity[i].value === this.form.cityCode) {
              this.form.cityName = this.selectCity[i].label
            }
          }
          for (let i = 0; i < this.selectArea.length; i++) {
            if (this.selectArea[i].value === this.form.areaCode) {
              this.form.areaName = this.selectArea[i].label
            }
          }
          this.birthdayValue = this.form.birthday
          this.form.birthday = moment(this.birthdayValue).format('YYYY-MM-DD')
          this.form.beginDay = moment(this.form.value1[0]).format('YYYY-MM-DD')
          this.form.endDay = moment(this.form.value1[1]).format('YYYY-MM-DD')
          let obj = this.optionsSys.find(item => {
            return item.value === this.form.systemId
          })
          this.form.systemName = obj.label
          let temp = []
          this.tableDataRole.forEach(item => {
            temp.push(item.id)
          })
          this.form.roleIds = temp
          let param = {
            data: this.form
          }
          this.$api.userList.userInsert(param).then((response) => {
            if (response.data.status === 'Y') {
              this.$message({
                message: response.data.message,
                type: 'success'
              })
              this.cancel()
            } else {
              this.$message({
                message: response.data.message,
                type: 'error'
              })
            }
          }).catch((error) => {
            console.log(error)
          })
        } else {
          console.log('error')
          return false
        }
      })
    },
    cancel () {
      this.$router.push({path: '/userList'})
      let tabItem = this.$store.getters.rightNav
      this.$store.dispatch('removeTab', {tabItem, fullPath: this.$route.fullPath, router: this.$router})
    },
    loadProvince () {
      this.$axios({
        method: 'post',
        url: this.global.BASE_INFO + '/pca/findProvince',
        headers: {
          certificate: Cookies.get(`token_${window.location.port}`)
        }
      }).then((response) => {
        // 循环添加所有数据
        this.selectData = response.data.data
      }).catch((error) => {
        console.log(error)
      })
    },
    loadCity (code) {
      this.$axios({
        method: 'post',
        url: this.global.BASE_INFO + '/pca/findCity',
        data: this.qs.stringify({
          provinceCode: code
        }),
        headers: {
          certificate: Cookies.get(`token_${window.location.port}`)
        }
      }).then((response) => {
        // 循环添加所有数据
        this.selectCity = response.data.data
      }).catch((error) => {
        console.log(error)
      })
    },
    loadArea (code) {
      this.$axios({
        method: 'post',
        url: this.global.BASE_INFO + '/pca/findArea',
        data: this.qs.stringify({
          cityCode: code
        }),
        headers: {
          certificate: Cookies.get(`token_${window.location.port}`)
        }
      }).then((response) => {
        this.selectArea = response.data.data
      }).catch((error) => {
        console.log(error)
      })
    },
    handleNodeClick (data) {
      this.form.deptCode = data.code
      this.form.deptName = data.label
    },
    initSysData () {
      this.$api.systemList.systemSelect().then((response) => {
        response.data.data.map((value, i) => {
          this.optionsSys.push({label: value.name, value: value.id})
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    comfirm () {
      this.dialogFormVisible = false
    },
    openTree () {
      this.dialogFormVisible = true
    },
    initUserType () {
      let param = {
        asp: 10,
        type: 'user_type'
      }
      this.$api.base.getDataDict(param).then((res) => {
        let data = res.data.data.infoList
        data.forEach(item => {
          this.optionUserType.push({value: item.code, label: item.name})
        })
      })
    }
  },
  computed: {
    CommitForm () {
      return {
        nameCn: [{required: true, trigger: 'blur', message: this.$t('base.info.user.UserNameCanNotBeEmpty')}],
        code: [{required: true, trigger: 'blur', message: this.$t('base.info.user.UserCodeCanNotBeEmpty')},
          {type: 'number', message: this.$t('base.info.user.PleaseEnterNum')}],
        mobile: [{required: true, trigger: 'blur', message: this.$t('base.info.user.MobileCanNotBeEmpty')},
          {pattern: /^[1]([3-9])[0-9]{9}$/, message: this.$t('base.info.user.PleaseEnterCorrectMobile')}],
        systemId: [{required: true, trigger: 'change', message: this.$t('base.info.user.SystemCanNotBeEmpty')}],
        //birthday: [{required: true, trigger: 'change', message: this.$t('base.info.user.BirthdayCanNotBeEmpty')}],
        //provinceCode: [{required: true, trigger: 'change', message: this.$t('base.info.user.ProvinceCanNotBeEmpty')}],
        //cityCode: [{required: true, trigger: 'change', message: this.$t('base.info.user.CityCanNotBeEmpty')}],
        //areaCode: [{required: true, trigger: 'change', message: this.$t('base.info.user.AreaCanNotBeEmpty')}]
        value1: [{required: true, trigger: 'change', message: this.$t('base.info.user.EffectiveTimeCanNotBeEmpty')}]
      }
    }
  },
  created () {
    this.loadProvince()
    this.initSysData()
    this.initUserType()
    this.$api.orgList.findAllByString(this.qs.stringify({type: 'select'})).then((response) => {
      this.tree = response.data.data
      this.form.orgCode = this.tree[0].code
      this.form.orgName = this.tree[0].label
    }).catch((error) => {
      console.log(error)
    })
  },
  message () {
    const h = this.$createElement
    this.$notify({
      title: '提示',
      message: h('i', {style: 'color: teal'}, ''),
      duration: 6000
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/user/userAdd.vue